import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=0f6f28e2&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"
import style0 from "./PDF.vue?vue&type=style&index=0&id=0f6f28e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f28e2",
  null
  
)

export default component.exports